/**
 * 卡片组件统一导出
 *
 * modeCode 映射关系：
 *   Card           → BaseCard              普通卡片式
 *   SingleImg      → SingleImg             单图
 *   GridCard       → GridCard              九宫格卡片（移动端2列，桌面2/3/4列可配）
 *   GridCard3      → GridCard3             九宫格3列卡片
 *   BannerBg       → BannerBg              滚动图片背景（视差）
 *   Text           → TextCard              纯文字
 *   TagBackground  → TagBackgroundCard     背景标签
 *   CardPerson     → CardPerson            卡片+人
 *   FAQCard        → FAQCard               FAQ折叠卡片
 *   DownloadCard   → DownloadCard          下载卡片
 *   TabCard        → TabCard               标签栏卡片
 *   ZigZag         → ZigZag                左右交叉布局
 *   ScrollImageCard→ ScrollImageCard       循环滚动图片卡片
 *   Accordion      → Accordion             手风琴折叠卡片
 */
export { default as BaseCard } from './BaseCard.vue'
export { default as SingleImg } from './SingleImg.vue'
export { default as GridCard } from './GridCard.vue'
export { default as GridCard3 } from './GridCard3.vue'
export { default as BannerBg } from './BannerBg.vue'
export { default as TextCard } from './TextCard.vue'
export { default as TagBackgroundCard } from './TagBackgroundCard.vue'
export { default as CardPerson } from './CardPerson.vue'
export { default as FAQCard } from './FAQCard.vue'
export { default as DownloadCard } from './DownloadCard.vue'
export { default as TabCard } from './TabCard.vue'
export { default as ZigZag } from './ZigZag.vue'
export { default as ScrollImageCard } from './ScrollImageCard.vue'
export { default as Accordion } from './Accordion.vue'

import type { Component } from 'vue'
import BaseCard from './BaseCard.vue'
import SingleImg from './SingleImg.vue'
import GridCard from './GridCard.vue'
import GridCard3 from './GridCard3.vue'
import BannerBg from './BannerBg.vue'
import TextCard from './TextCard.vue'
import TagBackgroundCard from './TagBackgroundCard.vue'
import CardPerson from './CardPerson.vue'
import FAQCard from './FAQCard.vue'
import DownloadCard from './DownloadCard.vue'
import TabCard from './TabCard.vue'
import ZigZag from './ZigZag.vue'
import ScrollImageCard from './ScrollImageCard.vue'
import Accordion from './Accordion.vue'
import Tab2Card from './Tab2Card.vue'
import ImgTopImgBottom from './ImgTopImgBottom.vue'
import ImageBgTitleTop from './ImageBgTitleTop.vue'
import TowColText from './TowColText.vue'
import TitleWithLine from './TitleWithLine.vue'
import BorderCard from './BorderCard.vue'
import UserCard from './UserCard.vue'
import ImgBgBottomTextCard from './ImgBgBottomTextCard.vue'
import TutorialSection from './TutorialSection.vue'
import TutorialVideoHtml from './TutorialVideoHtml.vue'
import CardSection from './CardSection.vue'

/** modeCode → 组件映射，用于动态组件渲染 */
export const CARD_COMPONENT_MAP: Record<string, Component> = {
  Card: BaseCard,
  SingleImg,
  GridCard,
  GridCard3,
  BannerBg,
  Text: TextCard,
  TagBackground: TagBackgroundCard,
  CardPerson,
  FAQCard,
  DownloadCard,
  TabCard,
  ZigZag,
  ScrollImageCard,
  Accordion,
  ImgTopImgBottom,
  Tab2: Tab2Card,
  ImageBgTitleTop,
  TitleWithLine,
  TowColText,
  BorderCard,
  UserCard,
  ImgBgBottomTextCard,
  CardSection,
  TutorialSection,
  TutorialVideoHtml,
}
export function asRecord(v: unknown): Record<string, unknown> {
  return (v as Record<string, unknown>) || {}
}

export function getStrWithRecord(v: unknown, key: string): string {
  const record = asRecord(v)
  return (record[key] || '') as string || ''
}

export function getBoolWithRecord(v: unknown, key: string, defaultValue = false): boolean {
  const record = asRecord(v)
  const val = record[key]
  return typeof val === 'boolean' ? val : defaultValue
}

export function getNumWithRecord(v: unknown, key: string, defaultValue = 1): number {
  const record = asRecord(v)
  const val = record[key]
  const num = Number(val)
  return Number.isFinite(num) && num > 0 ? num : defaultValue
}

export { isExternalUrl, getHref, jumpToUrl } from '@/utils/url'
